import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-fir-proce-grid',
  templateUrl: './fir-proce-grid.component.html',
  styleUrls: ['./fir-proce-grid.component.css']
})
export class FirProceGridComponent implements OnInit {
  
  // constructor() { }
  title = "Fir List";
  itemsPerPage: number=5;
  currentPage: number=1;
  ProceedingDetailsList : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;
  Fir_id : number;
  FirDetails : any = [];
  Proceedingdetails : any = {};  
  formInvalid: boolean;
  fileToUpload: File;
  p : any = {};
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$"; 
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {

    debugger;

    this.route.params.subscribe(params => {
      //  this.mode = params['mode'];
      this.Fir_id = params['Fir_id'];     
      this.GetFirDetails(this.Fir_id);  
      // this.GetProceedingDetails(this.itemsPerPage, 1);  
      this.GetProceedingDetails(this.itemsPerPage,1,this.Fir_id);  
      
    });


  }

  GetFirDetails(Fir_id){
    debugger;
  document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetFirProceedingetails(Fir_id);
    this.data.subscribe(
      (response: any) => {       
        this.FirDetails = response
        console.log('this.FirDetails');
        console.log(this.FirDetails);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  SaveProeeding(Proceeding: NgForm){  
    debugger; 
    
    if(Proceeding.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     
  
    else{                    
      Proceeding.value.FirId = this.Fir_id ;
      Proceeding.value.Proc_File_Path = this.getFeasibilityFirBriefFUrl();

      console.log('Save');
      console.log(Proceeding.value);
         
            this.data = this.userService.PostProceeding(Proceeding.value);    
            this.data.subscribe(
            (response) => {
              Proceeding.reset();
              Proceeding.resetForm();
              Proceeding.form.markAsPristine();
              Proceeding.form.markAsUntouched();        
              swal('Success!', 'Proceeding Added Successfully .', 'success');
              //this.router.navigate(['/home/investigation-doc/fir-prceeding']) ; 
              this.GetProceedingDetails(this.itemsPerPage,1,this.Fir_id);    
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });       
           
    } 
  }


//upload
  imageUpload1(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            //  this.IS_UploadPath = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage5(data);
          x.subscribe(
            (response) => {
              
            }, (error) => {
              let i: any = document.getElementById('Proc_File_Path');
              i.value = "";
              if (error.status == 400) {
                //this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('Proc_File_Path');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
    
    
    
      getFeasibilityFirBriefFUrl() {
        let imagename = null;      
        try {
          imagename = document.getElementById('Proc_File_Path');         
          console.log(imagename.files[0].name);
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }
  
      //getting Proceeding
      GetProceedingDetails(itemsPerPage:any,pageNo:any,Fir_id){
        debugger;
        //alert('Inside');
        this.isSearch = false;
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.userService.GetAllProceedingDetails(itemsPerPage,pageNo,Fir_id);
          this.data.subscribe(
            (response: any) => {
              this.ProceedingDetailsList = response.ProceedingModel;
                this.totalItems = response.TotalItemsCount;
                this.itemsPerPage = itemsPerPage;
                this.currentPage = pageNo;  
              document.getElementById('loader-spinner').style.display = "none";
            },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        } 
        
        
        pageChanged(pageNumber: number) {
         // if (this.isSearch)
            //this.onSearch(this.s,this.itemsPerPage, pageNumber);
          //else
            this.GetProceedingDetails(this.itemsPerPage, pageNumber,this.Fir_id);
        }
      
        itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
         // if (this.isSearch)
           // this.onSearch(this.s,this.itemsPerPage, pageNo);
         // else
            this.GetProceedingDetails(this.itemsPerPage, pageNo,this.Fir_id);
        }
    
    
      //Search item
    
    
      onSearch(Fir_id,s,itemsPerPage: number, pageNo: number) {  
        debugger; 
        this.isSearch = true;
        let searchText = this.s.SearchText;
        let searchCriteria = this.s.SearchCriteria;
        if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
          swal("Warning!", "Please enter the search criteria and search text.", "warning");
        else {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.GetProceedingOnSearch(this.Fir_id,searchCriteria, searchText, itemsPerPage,pageNo)
            .subscribe(
              (data: any) => {
                if(data.ProceedingModel.length!=0){              
                this.ProceedingDetailsList = data.ProceedingModel;
                this.totalItems = data.TotalItemsCount;
                this.currentPage = pageNo;
                document.getElementById('loader-spinner').style.display = "none";
              }
              else
              {
              document.getElementById('loader-spinner').style.display = "none";         
              }
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401|| error.status == 500) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
        }
      }
      delete(Proc_Id){
        swal({
             title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.value) {
            this.data = this.userService.DeleteProcById(Proc_Id);
            this.data.subscribe(
             (response: any) => {
                 this. GetProceedingDetails(this.itemsPerPage, 1,this.Fir_id)          
             },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            }       
          ); 
        } 
        })
        }
    
    
    }
    



// WEBPACK FOOTER //
// ./src/app/investigation-docs/fir-proceeding-list/fir-proce-grid/fir-proce-grid.component.ts